import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  ${({
    theme: {
      measures: {
        gutters: { horizontal },
      },
    },
  }) => {
    return css`
      display: grid;
      -ms-grid-columns: auto ${horizontal} 1fr;
      grid-template-columns: auto 1fr;
      justify-items: start;
      align-items: center;
      grid-gap: 0 ${horizontal};
    `
  }}
`

const Icon = styled.div`
  grid-template-columns: 1;
  display: grid;
  align-self: center;
  align-content: center;
  line-height: 0;
  width: 20px;
  height: 100%;

  > img {
    width: 100%;
    max-width: 17px;
    height: auto;
  }

  .basic-image {
    background-color: transparent;
  }
`

const Name = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_100 },
      },
    },
  }) => {
    return css`
      grid-template-columns: 3;
      align-self: center;
      color: ${grey_100};
      font-size: 17px;
      line-height: 1.5;
    `
  }}
`

interface Props {
  className?: string
  icon?: {
    Name: string
    URL: string
  }
}

const Label: FunctionComponent<Props> = ({ className, icon }) =>
  icon ? (
    <Wrapper className={className || ''}>
      <Icon>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={icon.URL}
          alt={icon.Name}
          width="1"
          height="1"
          loading="lazy"
        />
      </Icon>
      <Name>{icon.Name}</Name>
    </Wrapper>
  ) : null

export default Label
